/* eslint-disable import/prefer-default-export */

const appPrefix = 'APP';
const breadcrumbsPrefix = 'BC';
const segmentsComparePrefix = 'SEG_CMP';
const segmentsListPrefix = 'SEG_LIST';
const modelsListPrefix = 'MODELS_LIST';
const modelsViewPrefix = 'MODELS_VIEW';
const modelsAddPrefix = 'MODELS_ADD';
const modelsComparePrefix = 'MODELS_CMP';
const segmentsViewPrefix = 'SEG_VIEW';
const clustersPrefix = 'CLUSTERS';
const onboardingPrefix = 'ONBOARDING';
const usersPrefix = 'USERS';
const usersEditPrefix = 'USERS_EDIT';
const authPrefix = 'AUTH';
const rtApiListPrefix = 'RT_API_LIST';
const rtApiDemoPrefix = 'RT_API_DEMO';
const rtApiUsagePrefix = 'RT_API_USAGE';
const clientsEditPrefix = 'CLIENTS_EDIT';
const copyPxPrefix = 'COPY_PX';

export const RT_API_LIST = {
  UNSET: `${rtApiListPrefix}_UNSET`,
  FETCH_API_KEY: `${rtApiListPrefix}_FETCH_API_KEY`,
  FETCH_API_KEY_FAILURE: `${rtApiListPrefix}_FETCH_API_KEY_FAILURE`,
  FETCH_API_KEY_SUCCEEDED: `${rtApiListPrefix}_FETCH_API_KEY_SUCCEEDED`,
  FETCH_CONFIG_LIST: `${rtApiListPrefix}_FETCH_CONFIG_LIST`,
  FETCH_CONFIG_LIST_FAILURE: `${rtApiListPrefix}_FETCH_CONFIG_LIST_FAILURE`,
  FETCH_CONFIG_LIST_SUCCEEDED: `${rtApiListPrefix}_FETCH_CONFIG_LIST_SUCCEEDED`,
  FETCH_MODELS: `${rtApiListPrefix}_FETCH_MODELS`,
  FETCH_MODELS_SUCCEEDED: `${rtApiListPrefix}_FETCH_MODELS_SUCCEEDED`,
  FETCH_MODELS_FAILED: `${rtApiListPrefix}_FETCH_MODELS_FAILED`,
  APPROVE_CONFIG: `${rtApiListPrefix}_APPROVE_CONFIG`,
  APPROVE_CONFIG_FAILURE: `${rtApiListPrefix}_APPROVE_CONFIG_FAILURE`,
  APPROVE_CONFIG_SUCCEEDED: `${rtApiListPrefix}_APPROVE_CONFIG_SUCCEEDED`,
  CREATE_CONFIG: `${rtApiListPrefix}_CREATE_CONFIG`,
  CREATE_CONFIG_FAILURE: `${rtApiListPrefix}_CREATE_CONFIG_FAILURE`,
  CREATE_CONFIG_SUCCEEDED: `${rtApiListPrefix}_CREATE_CONFIG_SUCCEEDED`,
  DELETE_CONFIG: `${rtApiListPrefix}_DELETE_CONFIG`,
  DELETE_CONFIG_FAILURE: `${rtApiListPrefix}_DELETE_CONFIG_FAILURE`,
  DELETE_CONFIG_SUCCEEDED: `${rtApiListPrefix}_DELETE_CONFIG_SUCCEEDED`,
  EDIT_CONFIG: `${rtApiListPrefix}_EDIT_CONFIG`,
  EDIT_CONFIG_FAILURE: `${rtApiListPrefix}_EDIT_CONFIG_FAILURE`,
  EDIT_CONFIG_SUCCEEDED: `${rtApiListPrefix}_EDIT_CONFIG_SUCCEEDED`,
  SELECT_ROW: `${rtApiListPrefix}_SELECT_GRID_ROW`,
  DESELECT_ROW: `${rtApiListPrefix}_DESELECT_GRID_ROW`,
  SET_GRID_STATE: `${rtApiListPrefix}_SET_GRID_STATE`,
  SET_SELECTED_ROWS: `${rtApiListPrefix}_SET_SELECTED_GRID_ROWS`,
  DESELECT_ALL_ROWS: `${rtApiListPrefix}_DESELECT_ALL_ROWS`,
};

export const RT_API_DEMO = {
  UNSET: `${rtApiDemoPrefix}_UNSET`,
  FETCH_CONFIG: `${rtApiDemoPrefix}_FETCH_CONFIG`,
  FETCH_CONFIG_FAILURE: `${rtApiDemoPrefix}_FETCH_CONFIG_FAILURE`,
  FETCH_CONFIG_SUCCEEDED: `${rtApiDemoPrefix}_FETCH_CONFIG_SUCCEEDED`,
  SUBMIT_DEMO: `${rtApiListPrefix}_SUBMIT_DEMO_REQUEST`,
  SUBMIT_DEMO_FAILURE: `${rtApiListPrefix}_SUBMIT_DEMO_REQUEST_FAILURE`,
  SUBMIT_DEMO_SUCCEEDED: `${rtApiListPrefix}_SUBMIT_DEMO_REQUEST_SUCCEEDED`,
};

export const RT_API_USAGE = {
  UNSET: `${rtApiUsagePrefix}_UNSET`,
  RESET: `${rtApiUsagePrefix}_RESET`,
  UPDATE_FILTER: `${rtApiUsagePrefix}_UPDATE_FILTER`,
  FETCH_CONFIG_LIST: `${rtApiUsagePrefix}_FETCH_CONFIG_LIST`,
  FETCH_CONFIG_LIST_FAILURE: `${rtApiUsagePrefix}_FETCH_CONFIG_LIST_FAILURE`,
  FETCH_CONFIG_LIST_SUCCEEDED: `${rtApiUsagePrefix}_FETCH_CONFIG_LIST_SUCCEEDED`,
  FETCH_CONFIG_LIST_SUCCEEDED_EMPTY: `${rtApiUsagePrefix}_FETCH_CONFIG_LIST_SUCCEEDED_EMPTY`,
  FETCH_CONFIG: `${rtApiUsagePrefix}_FETCH_CONFIG`,
  FETCH_CONFIG_FAILURE: `${rtApiUsagePrefix}_FETCH_CONFIG_FAILURE`,
  FETCH_CONFIG_SUCCEEDED: `${rtApiUsagePrefix}_FETCH_CONFIG_SUCCEEDED`,
  FETCH_USAGE_ENTRIES: `${rtApiUsagePrefix}_FETCH_USAGE_ENTRIES`,
  FETCH_USAGE_ENTRIES_SUCCEEDED: `${rtApiUsagePrefix}_FETCH_USAGE_ENTRIES_SUCCEEDED`,
  FETCH_USAGE_ENTRIES_FAILED: `${rtApiUsagePrefix}_FETCH_USAGE_ENTRIES_FAILED`,
  FETCH_RTT_ENTRIES: `${rtApiUsagePrefix}_FETCH_RTT_ENTRIES`,
  FETCH_RTT_ENTRIES_SUCCEEDED: `${rtApiUsagePrefix}_FETCH_RTT_ENTRIES_SUCCEEDED`,
  FETCH_RTT_ENTRIES_FAILED: `${rtApiUsagePrefix}_FETCH_RTT_ENTRIES_FAILED`,
  GENERATE_USAGE_STATS: `${rtApiUsagePrefix}_GENERATE_USAGE_STATS`,
  GENERATE_USAGE_STATS_SUCCEEDED: `${rtApiUsagePrefix}_GENERATE_USAGE_STATS_SUCCEEDED`,
  GENERATE_USAGE_STATS_FAILED: `${rtApiUsagePrefix}_GENERATE_USAGE_STATS_FAILED`,
  GENERATE_RTT_STATS: `${rtApiUsagePrefix}_GENERATE_RTT_STATS`,
  GENERATE_RTT_STATS_SUCCEEDED: `${rtApiUsagePrefix}_GENERATE_RTT_STATS_SUCCEEDED`,
  GENERATE_RTT_STATS_FAILED: `${rtApiUsagePrefix}_GENERATE_RTT_STATS_FAILED`,
};

export const ONBOARDING = {
  CANCEL_FETCH_ONBOARDINGS: `${onboardingPrefix}_CANCEL_FETCH_ONBOARDINGS`,
  FETCH_ONBOARDINGS: `${onboardingPrefix}_FETCH_ONBOARDINGS`,
  FETCH_ONBOARDINGS_SUCCEEDED: `${onboardingPrefix}_FETCH_ONBOARDINGS_SUCCEEDED`,
  FETCH_ONBOARDINGS_FAILED: `${onboardingPrefix}_FETCH_ONBOARDINGS_FAILED`,
  SET_GRID_STATE: `${onboardingPrefix}_SET_GRID_STATE`,
  SELECT_GRID_ROW: `${onboardingPrefix}_SELECT_GRID_ROW`,
  DESELECT_GRID_ROW: `${onboardingPrefix}_DESELECT_GRID_ROW`,
  SET_SELECTED_GRID_ROWS: `${onboardingPrefix}_SELECTED_GRID_ROWS`,
  FETCH_CLIENT_ONB_CONFIG: `${onboardingPrefix}_FETCH_CLIENT_ONB_CONFIG`,
  FETCH_CLIENT_ONB_CONFIG_SUCCEEDED: `${onboardingPrefix}_FETCH_CLIENT_ONB_CONFIG_SUCCEEDED`,
  FETCH_CLIENT_ONB_CONFIG_FAILED: `${onboardingPrefix}_FETCH_CLIENT_ONB_CONFIG_FAILED`,
  GET_CUF: `${onboardingPrefix}_GET_CUF`,
  GET_CUF_SUCCEEDED: `${onboardingPrefix}_GET_CUF_SUCCEEDED`,
  GET_CUF_FAILED: `${onboardingPrefix}_GET_CUF_FAILED`,
  GET_ONBOARDING: `${onboardingPrefix}_GET_ONBOARDING`,
  GET_ONBOARDING_SUCCEEDED: `${onboardingPrefix}_GET_ONBOARDING_SUCCEEDED`,
  GET_ONBOARDING_FAILED: `${onboardingPrefix}_GET_ONBOARDING_FAILED`,
  GET_DATASET: `${onboardingPrefix}_GET_DATASET`,
  GET_DATASET_SUCCEEDED: `${onboardingPrefix}_GET_DATASET_SUCCEEDED`,
  GET_DATASET_FAILED: `${onboardingPrefix}_GET_DATASET_FAILED`,
  FETCH_CLIENT_BY_TENANT: `${onboardingPrefix}_CLIENT_BY_TENANT`,
  FETCH_CLIENT_BY_TENANT_SUCCEEDED: `${onboardingPrefix}_CLIENT_BY_TENANT_SUCCEEDED`,
  FETCH_CLIENT_BY_TENANT_FAILED: `${onboardingPrefix}_CLIENT_BY_TENANT_FAILED`,
  STAGE_FILES: `${onboardingPrefix}_STAGE_FILES`,
  UPLOAD_FILES: `${onboardingPrefix}_UPLOAD_FILES`,
  UPLOAD_FILES_SUCCEEDED: `${onboardingPrefix}_UPLOAD_FILES_SUCCEEDED`,
  UPLOAD_FILES_FAILED: `${onboardingPrefix}_UPLOAD_FILES_FAILED`,
  UPDATE_PROGRESS: `${onboardingPrefix}_UPDATE_PROGRESS`,
  SET_DATASET_NAME: `${onboardingPrefix}_SET_DATASET_NAME`,
  SET_DATASET_TAG: `${onboardingPrefix}_SET_DATASET_TAG`,
  SET_ONBOARDING_TYPE: `${onboardingPrefix}_SET_ONBOARDING_TYPE`,
  TRIGGER_DET_WORKFLOW: `${onboardingPrefix}_TRIGGER_DET_WORKFLOW`,
  TRIGGER_DET_WORKFLOW_SUCCEEDED: `${onboardingPrefix}_TRIGGER_DET_WORKFLOW_SUCCEEDED`,
  TRIGGER_DET_WORKFLOW_FAILED: `${onboardingPrefix}_TRIGGER_DET_WORKFLOW_FAILED`,
  APPROVE_DET_WORKFLOW: `${onboardingPrefix}_APPROVE_DET_WORKFLOW`,
  APPROVE_DET_WORKFLOW_SUCCEEDED: `${onboardingPrefix}_APPROVE_DET_WORKFLOW_SUCCEEDED`,
  APPROVE_DET_WORKFLOW_FAILED: `${onboardingPrefix}_APPROVE_DET_WORKFLOW_FAILED`,
  CONFIRM_DET_WORKFLOW: `${onboardingPrefix}_CONFIRM_DET_WORKFLOW`,
  CONFIRM_DET_WORKFLOW_SUCCEEDED: `${onboardingPrefix}_CONFIRM_DET_WORKFLOW_SUCCEEDED`,
  CONFIRM_DET_WORKFLOW_FAILED: `${onboardingPrefix}_CONFIRM_DET_WORKFLOW_FAILED`,
  DL_DROPPED_WORKFLOW: `${onboardingPrefix}_DL_DROPPED_WORKFLOW`,
  DL_DROPPED_WORKFLOW_FAILED: `${onboardingPrefix}_DL_DROPPED_WORKFLOW_FAILED`,
  UNSET: `${onboardingPrefix}_UNSET`,
  SET_REFRESH_ID: `${onboardingPrefix}_SET_REFRESH_ID`,
  FETCH_REFRESHES: `${onboardingPrefix}_FETCH_REFRESHES`,
  FETCH_REFRESHES_SUCCEEDED: `${onboardingPrefix}_FETCH_REFRESHES_SUCCEEDED`,
  FETCH_REFRESHES_FAILED: `${onboardingPrefix}_FETCH_REFRESHES_FAILED`,
};

export const SEG_CMP = {
  FETCH_SEGMENTS: `${segmentsComparePrefix}_FETCH_SEGMENTS`,
  FETCH_SEGMENTS_SUCCEEDED: `${segmentsComparePrefix}_FETCH_SEGMENTS_SUCCEEDED`,
  FETCH_SEGMENTS_FAILED: `${segmentsComparePrefix}_FETCH_SEGMENTS_FAILED`,
  EDIT_SEGMENT: `${segmentsComparePrefix}_EDIT_SEGMENT`,
  EDIT_SEGMENT_SUCCEEDED: `${segmentsComparePrefix}_EDIT_SEGMENT_SUCCEEDED`,
  EDIT_SEGMENT_FAILED: `${segmentsComparePrefix}_EDIT_SEGMENT_FAILED`,
  GENERATE_HISTOGRAM: `${segmentsComparePrefix}_GENERATE_HISTOGRAM`,
  GENERATE_HISTOGRAM_SUCCEEDED: `${segmentsComparePrefix}_GENERATE_HISTOGRAM_SUCCEEDED`,
  GENERATE_HISTOGRAM_FAILED: `${segmentsComparePrefix}_GENERATE_HISTOGRAM_FAILED`,
  UNSET: `${segmentsComparePrefix}_SEG_LIST`,
};

export const SEG_VIEW = {
  FETCH_ENTITY: `${segmentsViewPrefix}_FETCH_ENTITY`,
  FETCH_ENTITY_SUCCEEDED: `${segmentsViewPrefix}_FETCH_ENTITY_SUCCEEDED`,
  FETCH_ENTITY_FAILED: `${segmentsViewPrefix}_FETCH_ENTITY_FAILED`,
  EDIT_ENTITY: `${segmentsViewPrefix}_EDIT_ENTITY`,
  EDIT_ENTITY_SUCCEEDED: `${segmentsViewPrefix}_EDIT_ENTITY_SUCCEEDED`,
  EDIT_ENTITY_FAILED: `${segmentsViewPrefix}_EDIT_ENTITY_FAILED`,
  GENERATE_HISTOGRAM: `${segmentsViewPrefix}_GENERATE_HISTOGRAM`,
  GENERATE_HISTOGRAM_SUCCEEDED: `${segmentsViewPrefix}_GENERATE_HISTOGRAM_SUCCEEDED`,
  GENERATE_HISTOGRAM_FAILED: `${segmentsViewPrefix}_GENERATE_HISTOGRAM_FAILED`,
  UNSET: `${segmentsViewPrefix}_SEG_LIST`,
};

export const SEG_LIST = {
  FETCH_SEGMENTS: `${segmentsListPrefix}_FETCH_SEGMENTS`,
  FETCH_SEGMENTS_SUCCEEDED: `${segmentsListPrefix}_FETCH_SEGMENTS_SUCCEEDED`,
  FETCH_SEGMENTS_FAILED: `${segmentsListPrefix}_FETCH_SEGMENTS_FAILED`,
  DESELECT_ALL_SEGMENT_IDS: `${segmentsListPrefix}_DESELECT_ALL_SEGMENT_IDS`,
  SET_GRID_STATE: `${segmentsListPrefix}_SET_GRID_STATE`,
  SELECT_GRID_ROW: `${segmentsListPrefix}_SELECT_GRID_ROW`,
  DESELECT_GRID_ROW: `${segmentsListPrefix}_DESELECT_GRID_ROW`,
  SET_SELECTED_GRID_ROWS: `${segmentsListPrefix}_SELECTED_GRID_ROWS`,
  EDIT_DATASET: `${segmentsListPrefix}_EDIT_DATASET`,
  EDIT_DATASET_SUCCEEDED: `${segmentsListPrefix}_EDIT_DATASET_SUCCEEDED`,
  EDIT_DATASET_FAILED: `${segmentsListPrefix}_EDIT_DATASET_FAILED`,
  EDIT_SEGMENT: `${segmentsListPrefix}_EDIT_SEGMENT`,
  EDIT_SEGMENT_SUCCEEDED: `${segmentsListPrefix}_EDIT_SEGMENT_SUCCEEDED`,
  EDIT_SEGMENT_FAILED: `${segmentsListPrefix}_EDIT_SEGMENT_FAILED`,
  EDIT_CLUSTER: `${segmentsListPrefix}_EDIT_CLUSTER`,
  EDIT_CLUSTER_SUCCEEDED: `${segmentsListPrefix}_EDIT_CLUSTER_SUCCEEDED`,
  EDIT_CLUSTER_FAILED: `${segmentsListPrefix}_EDIT_CLUSTER_FAILED`,
  DELETE_SEGMENT: `${segmentsListPrefix}_DELETE_SEGMENT`,
  DELETE_SEGMENT_SUCCEEDED: `${segmentsListPrefix}_DELETE_SEGMENT_SUCCEEDED`,
  DELETE_SEGMENT_FAILED: `${segmentsListPrefix}_DELETE_SEGMENT_FAILED`,
  CHECK_DELETE_SEGMENT: `${segmentsListPrefix}_CHECK_DELETE_SEGMENT`,
  CHECK_DELETE_SEGMENT_SUCCEEDED: `${segmentsListPrefix}_CHECK_DELETE_SEGMENT_SUCCEEDED`,
  CHECK_DELETE_SEGMENT_FAILED: `${segmentsListPrefix}_CHECK_DELETE_SEGMENT_FAILED`,
  DELETE_CLUSTER: `${segmentsListPrefix}_DELETE_CLUSTER`,
  DELETE_CLUSTER_SUCCEEDED: `${segmentsListPrefix}_DELETE_CLUSTER_SUCCEEDED`,
  DELETE_CLUSTER_FAILED: `${segmentsListPrefix}_DELETE_CLUSTER_FAILED`,
  FETCH_DOWNLOAD_URL: `${segmentsListPrefix}_FETCH_DOWNLOAD_URL`,
  FETCH_DOWNLOAD_URL_SUCCEEDED: `${segmentsListPrefix}_FETCH_DOWNLOAD_URL_SUCCEEDED`,
  FETCH_DOWNLOAD_URL_FAILED: `${segmentsListPrefix}_FETCH_DOWNLOAD_URL_FAILED`,
  DELETE_DOWNLOAD: `${segmentsListPrefix}_DELETE_DOWNLOAD`,
  DELETE_DOWNLOAD_SUCCEEDED: `${segmentsListPrefix}_DELETE_DOWNLOAD_SUCCEEDED`,
  DELETE_DOWNLOAD_FAILED: `${segmentsListPrefix}_DELETE_DOWNLOAD_FAILED`,
  TOGGLE_VISIBILITY_DOWNLOAD: `${segmentsListPrefix}_TOGGLE_VISIBILITY_DOWNLOAD`,
  TOGGLE_VISIBILITY_DOWNLOAD_SUCCEEDED: `${segmentsListPrefix}_TOGGLE_VISIBILITY_DOWNLOAD_SUCCEEDED`,
  TOGGLE_VISIBILITY_DOWNLOAD_FAILED: `${segmentsListPrefix}_TOGGLE_VISIBILITY_DOWNLOAD_FAILED`,
  FETCH_CLIENT_BY_TENANT: `${segmentsListPrefix}_CLIENT_BY_TENANT`,
  FETCH_CLIENT_BY_TENANT_SUCCEEDED: `${segmentsListPrefix}_CLIENT_BY_TENANT_SUCCEEDED`,
  FETCH_CLIENT_BY_TENANT_FAILED: `${segmentsListPrefix}_CLIENT_BY_TENANT_FAILED`,
  CREATE_MODEL: `${segmentsListPrefix}_CREATE_MODEL`,
  CREATE_MODEL_SUCCEEDED: `${segmentsListPrefix}_CREATE_MODEL_SUCCEEDED`,
  CREATE_MODEL_FAILED: `${segmentsListPrefix}_CREATE_MODEL_FAILED`,
  FETCH_MODELS: `${segmentsListPrefix}_FETCH_MODELS`,
  FETCH_MODELS_SUCCEEDED: `${segmentsListPrefix}_FETCH_MODELS_SUCCEEDED`,
  FETCH_MODELS_FAILED: `${segmentsListPrefix}_FETCH_MODELS_FAILED`,
  ADD_MODEL_TARGET: `${segmentsListPrefix}_ADD_MODEL_TARGET`,
  ADD_MODEL_TARGET_SUCCEEDED: `${segmentsListPrefix}_ADD_MODEL_TARGET_SUCCEEDED`,
  ADD_MODEL_TARGET_FAILED: `${segmentsListPrefix}_ADD_MODEL_TARGET_FAILED`,
  UNSET: `${segmentsListPrefix}_UNSET`,
};

export const COPY_PX = {
  FETCH_SEGMENTS: `${copyPxPrefix}_FETCH_SEGMENTS`,
  FETCH_SEGMENTS_SUCCEEDED: `${copyPxPrefix}_FETCH_SEGMENTS_SUCCEEDED`,
  FETCH_SEGMENTS_FAILED: `${copyPxPrefix}_FETCH_SEGMENTS_FAILED`,
  FETCH_HIGH_VALUE_WORDS: `${copyPxPrefix}_FETCH_HIGH_VALUE_WORDS`,
  FETCH_HIGH_VALUE_WORDS_SUCCEEDED: `${copyPxPrefix}_FETCH_HIGH_VALUE_WORDS_SUCCEEDED`,
  FETCH_HIGH_VALUE_WORDS_FAILED: `${copyPxPrefix}_FETCH_HIGH_VALUE_WORDS_FAILED`,
  GENERATE_HIGH_VALUE_WORDS: `${copyPxPrefix}_GENERATE_HIGH_VALUE_WORDS`,
  GENERATE_HIGH_VALUE_WORDS_SUCCEEDED: `${copyPxPrefix}_GENERATE_HIGH_VALUE_WORDS_SUCCEEDED`,
  GENERATE_HIGH_VALUE_WORDS_FAILED: `${copyPxPrefix}_GENERATE_HIGH_VALUE_WORDS_FAILED`,
  SELECT_GRID_ROW: `${copyPxPrefix}_SELECT_GRID_ROW`,
  DESELECT_GRID_ROW: `${copyPxPrefix}_DESELECT_GRID_ROW`,
  SET_GRID_STATE: `${copyPxPrefix}_SET_GRID_STATE`,
  SET_SELECTED_GRID_ROWS: `${copyPxPrefix}_SELECTED_GRID_ROWS`,
  SET_COPY_PX: `${copyPxPrefix}_SET_COPY_PX`,
  DESELECT_ALL_GRID_ROWS: `${copyPxPrefix}_DESELECT_ALL_GRID_ROWS`,
  EDIT_SEGMENT: `${copyPxPrefix}_EDIT_SEGMENT`,
  EDIT_SEGMENT_SUCCEEDED: `${copyPxPrefix}_EDIT_SEGMENT_SUCCEEDED`,
  EDIT_SEGMENT_FAILED: `${copyPxPrefix}_EDIT_SEGMENT_FAILED`,
  UNSET: `${copyPxPrefix}_UNSET`,
};

export const CLUSTERS = {
  FETCH_SEGMENTS: `${clustersPrefix}_FETCH_SEGMENTS`,
  FETCH_SEGMENTS_SUCCEEDED: `${clustersPrefix}_FETCH_SEGMENTS_SUCCEEDED`,
  FETCH_SEGMENTS_FAILED: `${clustersPrefix}_FETCH_SEGMENTS_FAILED`,
  SAVE_CLUSTERING: `${clustersPrefix}_SAVE_CLUSTERING`,
  SAVE_CLUSTERING_SUCCEEDED: `${clustersPrefix}_SAVE_CLUSTERING_SUCCEEDED`,
  SAVE_CLUSTERING_FAILED: `${clustersPrefix}_SAVE_CLUSTERING_FAILED`,
  EDIT_CLUSTER: `${clustersPrefix}_EDIT_CLUSTER`,
  EDIT_CLUSTER_SUCCEEDED: `${clustersPrefix}_EDIT_CLUSTER_SUCCEEDED`,
  EDIT_CLUSTER_FAILED: `${clustersPrefix}_EDIT_CLUSTER_FAILED`,
  SET_CLUSTERING: `${clustersPrefix}_SET_CLUSTERING`,
  UNSET: `${clustersPrefix}_UNSET`,
};

export const MODELS_LIST = {
  FETCH_MODELS: `${modelsListPrefix}_FETCH_MODELS`,
  FETCH_MODELS_SUCCEEDED: `${modelsListPrefix}_FETCH_MODELS_SUCCEEDED`,
  FETCH_MODELS_FAILED: `${modelsListPrefix}_FETCH_MODELS_FAILED`,
  FETCH_MODEL_DL_FROM_ENTITY: `${modelsListPrefix}_FETCH_MODEL_DL_FROM_ENTITY`,
  FETCH_MODEL_DL_FROM_META: `${modelsListPrefix}_FETCH_MODEL_DL_FROM_META`,
  FETCH_MODEL_DL_SUCCEEDED: `${modelsListPrefix}_FETCH_MODEL_DL_SUCCEEDED`,
  FETCH_MODEL_DL_FAILED: `${modelsListPrefix}_FETCH_MODEL_DL_FAILED`,
  APPROVE_MODEL: `${modelsListPrefix}_APPROVE_MODEL`,
  APPROVE_MODEL_SUCCEEDED: `${modelsListPrefix}_APPROVE_MODEL_SUCCEEDED`,
  APPROVE_MODEL_FAILED: `${modelsListPrefix}_APPROVE_MODEL_FAILED`,
  SET_GRID_STATE: `${modelsListPrefix}_SET_GRID_STATE`,
  SELECT_GRID_ROW: `${modelsListPrefix}_SELECT_GRID_ROW`,
  DESELECT_GRID_ROW: `${modelsListPrefix}_DESELECT_GRID_ROW`,
  SET_SELECTED_GRID_ROWS: `${modelsListPrefix}_SELECTED_GRID_ROWS`,
  EDIT_MODEL: `${modelsListPrefix}_EDIT_MODEL`,
  EDIT_MODEL_SUCCEEDED: `${modelsListPrefix}_EDIT_MODEL_SUCCEEDED`,
  EDIT_MODEL_FAILED: `${modelsListPrefix}_EDIT_MODEL_FAILED`,
  HIDE_MODEL: `${modelsListPrefix}_HIDE_MODEL`,
  HIDE_MODEL_SUCCEEDED: `${modelsListPrefix}_HIDE_MODEL_SUCCEEDED`,
  HIDE_MODEL_FAILED: `${modelsListPrefix}_HIDE_MODEL_FAILED`,
  COPY_MODEL: `${modelsListPrefix}_COPY_MODEL`,
  COPY_MODEL_SUCCEEDED: `${modelsListPrefix}_COPY_MODEL_SUCCEEDED`,
  COPY_MODEL_FAILED: `${modelsListPrefix}_COPY_MODEL_FAILED`,
  SHOW_MODEL: `${modelsListPrefix}_SHOW_MODEL`,
  SHOW_MODEL_SUCCEEDED: `${modelsListPrefix}_SHOW_MODEL_SUCCEEDED`,
  SHOW_MODEL_FAILED: `${modelsListPrefix}_SHOW_MODEL_FAILED`,
  DELETE_MODEL: `${modelsListPrefix}_DELETE_MODEL`,
  DELETE_MODEL_SUCCEEDED: `${modelsListPrefix}_DELETE_MODEL_SUCCEEDED`,
  DELETE_MODEL_FAILED: `${modelsListPrefix}_DELETE_MODEL_FAILED`,
  CHECK_DELETE_MODEL: `${modelsListPrefix}_CHECK_DELETE_MODEL`,
  CHECK_DELETE_MODEL_SUCCEEDED: `${modelsListPrefix}_CHECK_DELETE_MODEL_SUCCEEDED`,
  CHECK_DELETE_MODEL_FAILED: `${modelsListPrefix}_CHECK_DELETE_MODEL_FAILED`,
  DESELECT_ALL_MODEL_IDS: `${modelsListPrefix}_DESELECT_ALL_MODEL_IDS`,
  DESELECT_ALL_MODEL_IDS_BY_TYPE: `${modelsListPrefix}_DESELECT_ALL_MODEL_IDS_BY_TYPE`,
  FETCH_CLIENT_BY_TENANT: `${modelsListPrefix}_CLIENT_BY_TENANT`,
  FETCH_CLIENT_BY_TENANT_SUCCEEDED: `${modelsListPrefix}_CLIENT_BY_TENANT_SUCCEEDED`,
  FETCH_CLIENT_BY_TENANT_FAILED: `${modelsListPrefix}_CLIENT_BY_TENANT_FAILED`,
  UNSET: `${modelsListPrefix}_UNSET`,
};

export const MODEL_VIEW = {
  INIT_ROI_CALCULATOR_STATE: `${modelsListPrefix}_INIT_ROI_CALCULATOR_STATE`,
  RESET_ROI_CALCULATOR_STATE_FIELD: `${modelsListPrefix}_RESET_ROI_CALCULATOR_STATE_FIELD`,
  UPDATE_ROI_CALCULATOR_STATE: `${modelsListPrefix}_UPDATE_ROI_CALCULATOR_STATE`,
  UPDATE_ROI_CALCULATOR_STATE_SUCCEEDED: `${modelsListPrefix}_UPDATE_ROI_CALCULATOR_STATE_SUCCEEDED`,
  UPDATE_ROI_CALCULATOR_STATE_FAILED: `${modelsListPrefix}_UPDATE_ROI_CALCULATOR_STATE_FAILED`,
  SAVE_ROI_CALCULATOR_STATE: `${modelsListPrefix}_SAVE_ROI_CALCULATOR_STATE`,
  SAVE_ROI_CALCULATOR_STATE_SUCCEEDED: `${modelsListPrefix}_SAVE_ROI_CALCULATOR_STATE_SUCCEEDED`,
  SAVE_ROI_CALCULATOR_STATE_FAILED: `${modelsListPrefix}_SAVE_ROI_CALCULATOR_STATE_FAILED`,
  EXPORT_ROI_CALCULATOR: `${modelsListPrefix}_EXPORT_ROI_CALCULATOR`,
  EXPORT_ROI_CALCULATOR_READY: `${modelsListPrefix}_EXPORT_ROI_CALCULATOR_READY`,
  EXPORT_ROI_CALCULATOR_FAILED: `${modelsListPrefix}_EXPORT_ROI_CALCULATOR_FAILED`,
  FETCH_MODEL: `${modelsViewPrefix}_FETCH_MODEL`,
  FETCH_MODEL_SUCCEEDED: `${modelsViewPrefix}_FETCH_MODEL_SUCCEEDED`,
  FETCH_MODEL_FAILED: `${modelsViewPrefix}_FETCH_MODEL_FAILED`,
  REMEDIATE_MODEL: `${modelsViewPrefix}_REMEDIATE_MODEL`,
  REMEDIATE_MODEL_SUCCEEDED: `${modelsViewPrefix}_REMEDIATE_MODEL_SUCCEEDED`,
  REMEDIATE_MODEL_FAILED: `${modelsViewPrefix}_REMEDIATE_MODEL_FAILED`,
  SET_CHART: `${modelsViewPrefix}_SET_CHART`,
  SET_EQUAL_TYPE: `${modelsViewPrefix}_SET_EQUAL_TYPE`,
  SET_QUANTILE_IDX: `${modelsViewPrefix}_SET_QUANTILE_IDX`,
  SET_QUANTILES: `${modelsViewPrefix}_SET_QUANTILES`,
  SET_AVAILABLE_QUANTILES: `${modelsViewPrefix}_SET_AVAILABLE_QUANTILES`,
  FETCH_DOWNLOAD_URL: `${modelsViewPrefix}_FETCH_DOWNLOAD_URL`,
  FETCH_DOWNLOAD_URL_SUCCEEDED: `${modelsViewPrefix}_FETCH_DOWNLOAD_URL_SUCCEEDED`,
  FETCH_DOWNLOAD_URL_FAILED: `${modelsViewPrefix}_FETCH_DOWNLOAD_URL_FAILED`,
  FETCH_INPUT_DIST_DOWNLOAD_URL: `${modelsViewPrefix}_FETCH_INPUT_DIST_DOWNLOAD_URL`,
  FETCH_INPUT_DIST_DOWNLOAD_URL_SUCCEEDED: `${modelsViewPrefix}_FETCH_INPUT_DIST_DOWNLOAD_URL_SUCCEEDED`,
  FETCH_INPUT_DIST_DOWNLOAD_URL_FAILED: `${modelsViewPrefix}_FETCH_INPUT_DIST_DOWNLOAD_URL_FAILED`,
  FETCH_LIFT_CHART_DOWNLOAD_URL: `${modelsViewPrefix}_FETCH_LIFT_CHART_DOWNLOAD_URL`,
  FETCH_LIFT_CHART_DOWNLOAD_URL_SUCCEEDED: `${modelsViewPrefix}_FETCH_LIFT_CHART_DOWNLOAD_URL_SUCCEEDED`,
  FETCH_LIFT_CHART_DOWNLOAD_URL_FAILED: `${modelsViewPrefix}_FETCH_LIFT_CHART_DOWNLOAD_URL_FAILED`,
  SET_ROI_CALC_SEED_FROM_DATASET: `${modelsViewPrefix}_SET_ROI_CALC_SEED_FROM_DATASET`,
  SET_GRADIENT: `${modelsViewPrefix}_SET_GRADIENT`,
  UNSET: `${modelsViewPrefix}_UNSET`,
  RESET_PAGE: `${modelsViewPrefix}_RESET_PAGE`,
};

export const MODELS_COMPARE = {
  FETCH_MODELS: `${modelsComparePrefix}_FETCH_MODELS`,
  FETCH_MODELS_SUCCEEDED: `${modelsComparePrefix}_FETCH_MODELS_SUCCEEDED`,
  FETCH_MODELS_FAILED: `${modelsComparePrefix}_FETCH_MODELS_FAILED`,
  SET_LIFT_SCORES: `${modelsComparePrefix}_SET_LIFT_SCORES`,
  SET_QUANTILES: `${modelsComparePrefix}_SET_QUANTILES`,
  SET_QUANTILE_INDICES: `${modelsComparePrefix}_SET_QUANTILE_INDICES`,
  SET_EQUAL_TYPE: `${modelsComparePrefix}_SET_EQUAL_TYPE`,
  SET_AVAILABLE_QUANTILES: `${modelsComparePrefix}_SET_AVAILABLE_QUANTILES`,
  SET_CHART: `${modelsComparePrefix}_SET_CHART`,
  SET_ROI_CALC_SEEDS_FROM_DATASETS: `${modelsComparePrefix}_SET_ROI_CALC_SEEDS_FROM_DATASETS`,
  UNSET: `${modelsComparePrefix}_UNSET`,
  RESET_PAGE: `${modelsComparePrefix}_RESET_PAGE`,
};

export const MODELS_ADD = {
  FETCH_SEGMENTS: `${modelsAddPrefix}_FETCH_SEGMENTS`,
  FETCH_SEGMENTS_SUCCEEDED: `${modelsAddPrefix}_FETCH_SEGMENTS_SUCCEEDED`,
  FETCH_SEGMENTS_FAILED: `${modelsAddPrefix}_FETCH_SEGMENTS_FAILED`,
  ADD_MODEL: `${modelsAddPrefix}_ADD_MODEL`,
  ADD_MODEL_SUCCEEDED: `${modelsAddPrefix}_ADD_MODEL_SUCCEEDED`,
  ADD_MODEL_FAILED: `${modelsAddPrefix}_ADD_MODEL_FAILED`,
  UNSET: `${modelsAddPrefix}_UNSET`,
};

export const BC = {
  SET_DATASET_ID: `${breadcrumbsPrefix}_SET_DATASET_ID`,
  SET_DATASET_NAME: `${breadcrumbsPrefix}_SET_DATASET_NAME`,
  SET_SEGMENT_ID: `${breadcrumbsPrefix}_SET_SEGMENT_ID`,
  SET_SEGMENT_NAME: `${breadcrumbsPrefix}_SET_SEGMENT_NAME`,
  SET_SEGMENT_NAMES: `${breadcrumbsPrefix}_SET_SEGMENT_NAMES`,
  SET_MODEL_NAME: `${breadcrumbsPrefix}_SET_MODEL_NAME`,
  SET_MODEL_NAMES: `${breadcrumbsPrefix}_SET_MODEL_NAMES`,
  SET_USER_EMAIL: `${breadcrumbsPrefix}_SET_USER_EMAIL`,
  RESET: `${breadcrumbsPrefix}_RESET`,
};

export const USERS = {
  FETCH_USERS: `${usersPrefix}_FETCH_USERS`,
  FETCH_USERS_SUCCEEDED: `${usersPrefix}_FETCH_USERS_SUCCEEDED`,
  FETCH_USERS_FAILED: `${usersPrefix}_FETCH_USERS_FAILED`,
  ADD_USER: `${usersPrefix}_ADD_USER`,
  ADD_USER_SUCCEEDED: `${usersPrefix}_ADD_USER_SUCCEEDED`,
  ADD_USER_FAILED: `${usersPrefix}_ADD_USER_FAILED`,
  EDIT_USER: `${usersPrefix}_EDIT_USER`,
  EDIT_USER_SUCCEEDED: `${usersPrefix}_EDIT_USER_SUCCEEDED`,
  EDIT_USER_FAILED: `${usersPrefix}_EDIT_USER_FAILED`,
  DEACTIVATE_USER: `${usersPrefix}_DEACTIVATE_USER`,
  DEACTIVATE_USER_SUCCEEDED: `${usersPrefix}_DEACTIVATE_USER_SUCCEEDED`,
  DEACTIVATE_USER_FAILED: `${usersPrefix}_DEACTIVATE_USER_FAILED`,
  ACTIVATE_USER: `${usersPrefix}_ACTIVATE_USER`,
  ACTIVATE_USER_SUCCEEDED: `${usersPrefix}_ACTIVATE_USER_SUCCEEDED`,
  ACTIVATE_USER_FAILED: `${usersPrefix}_ACTIVATE_USER_FAILED`,
  UNSET: `${usersPrefix}_UNSET`,
};

export const USERS_EDIT = {
  FETCH_USER: `${usersEditPrefix}_FETCH_USER`,
  FETCH_USER_SUCCEEDED: `${usersEditPrefix}_FETCH_USER_SUCCEEDED`,
  FETCH_USER_FAILED: `${usersEditPrefix}_FETCH_USER_FAILED`,
  EDIT_USER: `${usersEditPrefix}_EDIT_USER`,
  EDIT_USER_SUCCEEDED: `${usersEditPrefix}_EDIT_USER_SUCCEEDED`,
  EDIT_USER_FAILED: `${usersEditPrefix}_EDIT_USER_FAILED`,
  RESEND_INVITATION: `${usersEditPrefix}_RESEND_INVITATION`,
  RESEND_INVITATION_SUCCEEDED: `${usersEditPrefix}_RESEND_INVITATION_SUCCEEDED`,
  RESEND_INVITATION_FAILED: `${usersEditPrefix}_RESEND_INVITATION_FAILED`,
  RESET_PASSWORD: `${usersEditPrefix}_RESET_PASSWORD`,
  RESET_PASSWORD_SUCCEEDED: `${usersEditPrefix}_RESET_PASSWORD_SUCCEEDED`,
  RESET_PASSWORD_FAILED: `${usersEditPrefix}_RESET_PASSWORD_FAILED`,
  UNSET: `${usersEditPrefix}_UNSET`,
};

export const CLIENTS_EDIT = {
  FETCH_CLIENT: `${clientsEditPrefix}_FETCH_CLIENT`,
  FETCH_CLIENT_SUCCEEDED: `${clientsEditPrefix}_FETCH_CLIENT_SUCCEEDED`,
  FETCH_CLIENT_FAILED: `${clientsEditPrefix}_FETCH_CLIENT_FAILED`,
  ENABLE_REAL_TIME_API: `${clientsEditPrefix}_ENABLE_REAL_TIME_API`,
  ENABLE_REAL_TIME_API_SUCCEEDED: `${clientsEditPrefix}_ENABLE_REAL_TIME_API_SUCCEEDED`,
  ENABLE_REAL_TIME_API_FAILED: `${clientsEditPrefix}_ENABLE_REAL_TIME_API_FAILED`,
  DISABLE_REAL_TIME_API: `${clientsEditPrefix}_DISABLE_REAL_TIME_API`,
  DISABLE_REAL_TIME_API_SUCCEEDED: `${clientsEditPrefix}_DISABLE_REAL_TIME_API_SUCCEEDED`,
  DISABLE_REAL_TIME_API_FAILED: `${clientsEditPrefix}_DISABLE_REAL_TIME_API_FAILED`,
  EDIT_CLIENT: `${clientsEditPrefix}_EDIT_CLIENT`,
  EDIT_CLIENT_SUCCEEDED: `${clientsEditPrefix}_EDIT_CLIENT_SUCCEEDED`,
  EDIT_CLIENT_FAILED: `${clientsEditPrefix}_EDIT_CLIENT_FAILED`,
  FETCH_ONB_CONFIG_TYPES: `${clientsEditPrefix}_FETCH_ONB_CONFIG_TYPES`,
  FETCH_ONB_CONFIG_TYPES_SUCCEEDED: `${clientsEditPrefix}_FETCH_ONB_CONFIG_TYPES_SUCCEEDED`,
  FETCH_ONB_CONFIG_TYPES_FAILED: `${clientsEditPrefix}_FETCH_ONB_CONFIG_TYPES_FAILED`,
  FETCH_CLIENT_ONB_CONFIG: `${clientsEditPrefix}_FETCH_CLIENT_ONB_CONFIG`,
  FETCH_CLIENT_ONB_CONFIG_SUCCEEDED: `${clientsEditPrefix}_FETCH_CLIENT_ONB_CONFIG_SUCCEEDED`,
  FETCH_CLIENT_ONB_CONFIG_FAILED: `${clientsEditPrefix}_FETCH_CLIENT_ONB_CONFIG_FAILED`,
  FETCH_ONB_CONFIGS_L1: `${clientsEditPrefix}_FETCH_ONB_CONFIGS_L1`,
  FETCH_ONB_CONFIGS_L1_SUCCEEDED: `${clientsEditPrefix}_FETCH_ONB_CONFIGS_L1_SUCCEEDED`,
  FETCH_ONB_CONFIGS_L1_FAILED: `${clientsEditPrefix}_FETCH_ONB_CONFIGS_L1_FAILED`,
  FETCH_ONB_CONFIGS_L2: `${clientsEditPrefix}_FETCH_ONB_CONFIGS_L2`,
  FETCH_ONB_CONFIGS_L2_SUCCEEDED: `${clientsEditPrefix}_FETCH_ONB_CONFIGS_L2_SUCCEEDED`,
  FETCH_ONB_CONFIGS_L2_FAILED: `${clientsEditPrefix}_FETCH_ONB_CONFIGS_L2_FAILED`,
  FETCH_ONB_CONFIGS_L3: `${clientsEditPrefix}_FETCH_ONB_CONFIGS_L3`,
  FETCH_ONB_CONFIGS_L3_SUCCEEDED: `${clientsEditPrefix}_FETCH_ONB_CONFIGS_L3_SUCCEEDED`,
  FETCH_ONB_CONFIGS_L3_FAILED: `${clientsEditPrefix}_FETCH_ONB_CONFIGS_L3_FAILED`,
  EDIT_ONB_CONFIG: `${clientsEditPrefix}_EDIT_ONB_CONFIG`,
  EDIT_ONB_CONFIG_SUCCEEDED: `${clientsEditPrefix}_EDIT_ONB_CONFIG_SUCCEEDED`,
  EDIT_ONB_CONFIG_FAILED: `${clientsEditPrefix}_EDIT_ONB_CONFIG_FAILED`,
  ADD_ONB_CONFIG: `${clientsEditPrefix}_ADD_ONB_CONFIG`,
  ADD_ONB_CONFIG_SUCCEEDED: `${clientsEditPrefix}_ADD_ONB_CONFIG_SUCCEEDED`,
  ADD_ONB_CONFIG_FAILED: `${clientsEditPrefix}_ADD_ONB_CONFIG_FAILED`,
  UPDATE_SUBSCRIBED: `${clientsEditPrefix}_UPDATE_SUBSCRIBED`,
  UPDATE_SUBSCRIBED_SUCCEEDED: `${clientsEditPrefix}_UPDATE_SUBSCRIBED_SUCCEEDED`,
  UPDATE_SUBSCRIBED_FAILED: `${clientsEditPrefix}_UPDATE_SUBSCRIBED_FAILED`,
  FETCH_POSSIBLE_SUBSCRIBERS: `${clientsEditPrefix}_FETCH_POSSIBLE_SUBSCRIBERS`,
  FETCH_POSSIBLE_SUBSCRIBERS_SUCCEEDED: `${clientsEditPrefix}_FETCH_POSSIBLE_SUBSCRIBERS_SUCCEEDED`,
  FETCH_POSSIBLE_SUBSCRIBERS_FAILED: `${clientsEditPrefix}_FETCH_POSSIBLE_SUBSCRIBERS_FAILED`,
  FETCH_SUBSCRIBED: `${clientsEditPrefix}_FETCH_SUBSCRIBED`,
  FETCH_SUBSCRIBED_SUCCEEDED: `${clientsEditPrefix}_FETCH_SUBSCRIBED_SUCCEEDED`,
  FETCH_SUBSCRIBED_FAILED: `${clientsEditPrefix}_FETCH_SUBSCRIBED_FAILED`,
  UNSET: `${clientsEditPrefix}_UNSET`,
};

export const APP = {
  TOGGLE_MENU: `${appPrefix}_SET_APP`,
  FETCH_PROFILE: `${appPrefix}_FETCH_PROFILE`,
  FETCH_PROFILE_SUCCEEDED: `${appPrefix}_FETCH_PROFILE_SUCCEEDED`,
  FETCH_PROFILE_FAILED: `${appPrefix}_FETCH_PROFILE_FAILED`,
  FETCH_CLIENTS: `${appPrefix}_FETCH_CLIENTS`,
  FETCH_CLIENTS_SUCCEEDED: `${appPrefix}_FETCH_CLIENTS_SUCCEEDED`,
  FETCH_CLIENTS_FAILED: `${appPrefix}_FETCH_CLIENTS_FAILED`,
  SELECT_CLIENT: `${appPrefix}_SELECT_CLIENT`,
  SELECT_CLIENT_SUCCEEDED: `${appPrefix}_SELECT_CLIENT_SUCCEEDED`,
  SELECT_CLIENT_FAILED: `${appPrefix}_SELECT_CLIENT_FAILED`,
  SET_DATASET_ID: `${appPrefix}_SET_DATASET_ID`,
  FETCH_DATASETS: `${appPrefix}_FETCH_DATASETS`,
  FETCH_DATASETS_SUCCEEDED: `${appPrefix}_FETCH_DATASETS_SUCCEEDED`,
  FETCH_DATASETS_FAILED: `${appPrefix}_FETCH_DATASETS_FAILED`,
  SET_SEGMENT_ID: `${appPrefix}_SET_SEGMENT_ID`,
  REGISTER: `${appPrefix}_REGISTER`,
  REGISTER_SUCCEEDED: `${appPrefix}_REGISTER_SUCCEEDED`,
  REGISTER_FAILED: `${appPrefix}_REGISTER_FAILED`,
  ADD_CLIENT: `${appPrefix}_ADD_CLIENT`,
  ADD_CLIENT_SUCCEEDED: `${appPrefix}_ADD_CLIENT_SUCCEEDED`,
  ADD_CLIENT_FAILED: `${appPrefix}_ADD_CLIENT_FAILED`,
  DEL_CLIENT: `${appPrefix}_DEL_CLIENT`,
  DEL_CLIENT_SUCCEEDED: `${appPrefix}_DEL_CLIENT_SUCCEEDED`,
  DEL_CLIENT_FAILED: `${appPrefix}_DEL_CLIENT_FAILED`,
  UNSET: `${appPrefix}_UNSET`,
  SET_TENANT: `${appPrefix}_SET_TENANT`,
  SET_CLIENT: `${appPrefix}_SET_CLIENT`,
  SELECT_DATASET_ID: `${appPrefix}_SELECT_DATASET_ID`,
  DESELECT_DATASET_ID: `${appPrefix}_DESELECT_DATASET_ID`,
  DESELECT_ALL_DATASET_IDS: `${appPrefix}_DESELECT_ALL_DATASET_IDS`,
  ENQUEUE_NOTIFICATION: `${appPrefix}_ENQUEUE_NOTIFICATION`,
  DEQUEUE_NOTIFICATION: `${appPrefix}_DEQUEUE_NOTIFICATION`,
  FLASH_MESSAGE: `${appPrefix}_FLASH_MESSAGE`,
  HIDE_MESSAGE: `${appPrefix}_HIDE_MESSAGE`,
  OPEN_TOUR: `${appPrefix}_OPEN_TOUR`,
  SET_TOUR_STEPS: `${appPrefix}_SET_TOUR_STEPS`,
  CLOSE_TOUR: `${appPrefix}_CLOSE_TOUR`,
  FLYOVER_OPEN_STATUS: `${appPrefix}_FLYOVER_OPEN_STATUS`,
  SET_FLYOVER_OPEN_STATUS: `${appPrefix}_SET_FLYOVER_OPEN_STATUS`,
  FLYOVER_PIN_STATUS: `${appPrefix}_FLYOVER_PIN_STATUS`,
  SET_FLYOVER_PIN_STATUS: `${appPrefix}_SET_FLYOVER_PIN_STATUS`,
  SUBMIT_FEEDBACK: `${appPrefix}_SUBMIT_FEEDBACK`,
  SUBMIT_FEEDBACK_SUCCEEDED: `${appPrefix}_SUBMIT_FEEDBACK_SUCCEEDED`,
  SUBMIT_FEEDBACK_FAILED: `${appPrefix}_SUBMIT_FEEDBACK_FAILED`,
  GET_PRESIGNED_URL: `${appPrefix}_GET_PRESIGNED_URL`,
  GET_PRESIGNED_URL_SUCCEEDED: `${appPrefix}_GET_PRESIGNED_URL_SUCCEEDED`,
  GET_PRESIGNED_URL_FAILED: `${appPrefix}_GET_PRESIGNED_URL_FAILED`,
  GET_URL_FOR_DL: `${appPrefix}_GET_URL_FOR_DL`,
  GET_URL_FOR_DL_SUCCEEDED: `${appPrefix}_GET_URL_FOR_DL_SUCCEEDED`,
  GET_URL_FOR_DL_FAILED: `${appPrefix}_GET_URL_FOR_DL_FAILED`,
};

export const AUTH = {
  LOGIN: `${authPrefix}_LOGIN`,
  LOGIN_SUCCEEDED: `${authPrefix}_LOGIN_SUCCEEDED`,
  LOGIN_FAILED: `${authPrefix}_LOGIN_FAILED`,
  PASSWORD_RESET: `${authPrefix}_PASSWORD_RESET`,
  LOGOUT: `${authPrefix}_LOGOUT`,
  LOGOUT_SUCCEEDED: `${authPrefix}_LOGOUT_SUCCEEDED`,
  LOGOUT_FAILED: `${authPrefix}_LOGOUT_FAILED`,
  FORGOT_PASSWORD: `${authPrefix}_FORGOT_PASSWORD`,
  FORGOT_PASSWORD_SUCCEEDED: `${authPrefix}_FORGOT_PASSWORD_SUCCEEDED`,
  FORGOT_PASSWORD_FAILED: `${authPrefix}_FORGOT_PASSWORD_FAILED`,
  CHANGE_PASSWORD: `${authPrefix}_CHANGE_PASSWORD`,
  CHANGE_PASSWORD_SUCCEEDED: `${authPrefix}_CHANGE_PASSWORD_SUCCEEDED`,
  CHANGE_PASSWORD_FAILED: `${authPrefix}_CHANGE_PASSWORD_FAILED`,
  PASSWORD_CHALLENGE: `${authPrefix}_PASSWORD_CHALLENGE`,
  PASSWORD_CHALLENGE_RESPONSE: `${authPrefix}_PASSWORD_CHALLENGE_RESPONSE`,
  PASSWORD_CHALLENGE_RESPONSE_SUCCEEDED: `${authPrefix}_PASSWORD_CHALLENGE_RESPONSE_SUCCEEDED`,
  PASSWORD_CHALLENGE_RESPONSE_FAILED: `${authPrefix}_PASSWORD_CHALLENGE_RESPONSE_FAILED`,
  RESEND_INVITATION: `${authPrefix}_RESEND_INVITATION`,
  RESEND_INVITATION_SUCCEEDED: `${authPrefix}_RESEND_INVITATION_SUCCEEDED`,
  RESEND_INVITATION_FAILED: `${authPrefix}_RESEND_INVITATION_FAILED`,
  UNSET: `${authPrefix}_UNSET`,
};
